import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Subestatus } from '@p-p-portafolio/interfaces/subestatus';
import { SwalService } from '@shared/utils/swal.service';
import { ControlsService } from '@shared/services/controls/controls.service';
import { SubestatusService } from '@p-p-portafolio/services/subestatus.service';
import { ControlBase } from '@shared/components/generic-form/models/control-base';

@Component({
  selector: 'app_formaPago-form',
  templateUrl: './subestatus-form.component.html',
  styleUrls: ['./subestatus-form.component.css'],
})
export class SubestatusFormComponent implements OnInit {
  title: 'Nuevo' | 'Editar' = 'Editar';
  controls$: Observable<ControlBase<any>[]>;

  form: UntypedFormGroup;

  screenId: number = 16;

  constructor(
    public subestatusService: SubestatusService,
    private controlService: ControlsService,
    private swalService: SwalService
  ) {}

  ngOnInit(): void {
    // Is new data
    if (this.subestatusService.form.get('clave').value === null) {
      this.title = 'Nuevo';
    }

    this.controls$ = this.controlService.getControls(this.screenId);

    this.form = this.subestatusService.form;
  }

  onSubmit(payload: Subestatus) {

    if (this.title === 'Nuevo') {
      this.add(payload);
    } else {
      this.update(payload);
    }
  }

  add(payload){
    payload = JSON.parse(payload);
    payload.efectivo = +payload.efectivo;
    payload.pedir_Autorizacion = +payload.pedir_Autorizacion;
    payload.pedir_Referencia = +payload.pedir_Referencia;
    this.subestatusService.add(payload).subscribe(
      (res) => {
        if (res.success) {
          this.swalService.success('El concepto se ha añadido correctamente');
        } else {
          this.swalService.error(res.errors[0]);
        }
      },
      (error) => {
        this.swalService.error(error);
      }
    );
  }

  update(payload: Subestatus){
    this.subestatusService.update(payload).subscribe(
      (res) => {
        if (res.success) {
          this.swalService.success('Actualizado correctamente');
        } else {
          this.swalService.error(res.errors[0]);
        }
      },
      (error) => {
        this.swalService.error(error);
      }
    );
  }
}
